export interface FooterLink {
  title: string;
  link: string;
  isFirstLine: boolean;
}

export const FOOTER_LINKS_DATA: FooterLink[] = [
  {
    title: "Home",
    link: "/",
    isFirstLine: true,
  },
  {
    title: "About Us",
    link: "/about-us",
    isFirstLine: true,
  },
  {
    title: "Services",
    link: "/services",
    isFirstLine: true,
  },
  {
    title: "Our Work",
    link: "/our-work",
    isFirstLine: true,
  },
  {
    title: "Contact",
    link: "/contact",
    isFirstLine: true,
  },
  // {
  //   title: "Blog",
  //   link: "/blog",
  //   isFirstLine: false,
  // },
  // {
  //   title: "Career",
  //   link: "/career",
  //   isFirstLine: false,
  // },
]; 